import React from 'react';

import Spin from '../../../../../../shared/components/spin';
import { i18n } from '../../../../../../shared/helpers/i18n';
import { ToolbarOption } from '../../toolbar-option';

export function WaitingCloudRecordingOption() {
    const title = i18n('toolbar', 'cloud-recording-prepare');

    return <ToolbarOption icon={<Spin size="md" color="white" progress />} title={title} content={title} />;
}
